import React from 'react';

const MinimalInvoice = ({ invoice, seller }) => {
  const isInterState = invoice.sellerState !== invoice.placeOfSupply;
  
  return (
    <div className="p-10 w-[210mm] min-h-[297mm] mx-auto bg-white text-gray-800 font-sans shadow-lg">
      <div className="flex justify-between items-start mb-10">
        <div>
          <img src={seller?.logo} alt="Company Logo" className="h-12 mb-2 object-contain" />
          <h1 className="text-lg font-bold uppercase tracking-tight">{seller?.name}</h1>
          <p className="text-xs text-gray-500 whitespace-pre-line">{seller?.address}</p>
          <p className="text-xs font-semibold mt-1">GSTIN: {seller?.gstin}</p>
        </div>
        <div className="text-right">
          <h2 className="text-3xl font-light text-gray-400 uppercase mb-4">Tax Invoice</h2>
          <p className="text-sm"><strong>Invoice #:</strong> {invoice.invoiceNo}</p>
          <p className="text-sm"><strong>Date:</strong> {invoice.invoiceDate}</p>
          <p className="text-sm text-red-600"><strong>Due Date:</strong> {invoice.dueDate}</p>
        </div>
      </div>

      <hr className="border-gray-100 mb-6" />

      <div className="grid grid-cols-2 gap-8 mb-10">
        <div>
          <p className="text-[10px] uppercase text-gray-400 font-bold mb-1">Bill To</p>
          <p className="font-bold text-gray-700">{invoice.customerName}</p>
          <p className="text-xs text-gray-500 w-2/3">{invoice.shippingAddress}</p>
          <p className="text-xs font-semibold mt-1">GSTIN: {invoice.customerGstin}</p>
        </div>
        <div className="text-right">
          <p className="text-[10px] uppercase text-gray-400 font-bold mb-1">Place of Supply</p>
          <p className="text-sm">{invoice.placeOfSupply}</p>
        </div>
      </div>

      <table className="w-full text-left mb-8">
        <thead>
          <tr className="border-b-2 border-gray-800 text-[11px] uppercase tracking-wider">
            <th className="py-2">Description</th>
            <th className="py-2">HSN</th>
            <th className="py-2 text-right">Qty</th>
            <th className="py-2 text-right">Rate</th>
            <th className="py-2 text-right">Disc.</th>
            <th className="py-2 text-right">GST %</th>
            <th className="py-2 text-right">Amount</th>
          </tr>
        </thead>
        <tbody className="text-sm divide-y divide-gray-100">
          {invoice.items.map((item, i) => {
            const lineTotal = (Number(item.qty) * Number(item.rate)) - Number(item.discount);
            return (
              <tr key={i}>
                <td className="py-3 font-medium">{item.name}</td>
                <td className="py-3 text-xs text-gray-500">{item.hsn}</td>
                <td className="py-3 text-right">{item.qty} {item.unit}</td>
                <td className="py-3 text-right">₹{item.rate}</td>
                <td className="py-3 text-right text-gray-400">-{item.discount}</td>
                <td className="py-3 text-right">{item.gstRate}%</td>
                <td className="py-3 text-right font-semibold text-gray-700">₹{lineTotal.toFixed(2)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="flex justify-between">
        {/* <div className="w-1/2">
          <h3 className="text-[10px] uppercase font-bold text-gray-400 mb-2">Payment Information</h3>
          <div className="text-[11px] text-gray-600 border p-3 rounded bg-gray-50">
            <p><strong>Bank:</strong> {seller?.bankDetails?.bankName}</p>
            <p><strong>A/C:</strong> {seller?.bankDetails?.accountNo}</p>
            <p><strong>IFSC:</strong> {seller?.bankDetails?.ifsc}</p>
          </div>
        </div> */}
        <div className='w-1/2'></div>
        
        <div className="w-1/3 text-sm">
          <div className="flex justify-between py-1">
            <span className="text-gray-500">Subtotal</span>
            <span>₹{invoice.total - (invoice.total * 0.18)}</span>
          </div>
          
          {isInterState ? (
            <div className="flex justify-between py-1 border-b">
              <span className="text-gray-500">IGST</span>
              <span>₹{(invoice.total * 0.18).toFixed(2)}</span>
            </div>
          ) : (
            <>
              <div className="flex justify-between py-1">
                <span className="text-gray-500">CGST</span>
                <span>₹{(invoice.total * 0.09).toFixed(2)}</span>
              </div>
              <div className="flex justify-between py-1 border-b">
                <span className="text-gray-500">SGST</span>
                <span>₹{(invoice.total * 0.09).toFixed(2)}</span>
              </div>
            </>
          )}

          <div className="flex justify-between py-3 font-bold text-lg border-b-2 border-double border-gray-800">
            <span>Total</span>
            <span>₹{invoice.total.toLocaleString('en-IN')}</span>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-gray-100">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-[10px] uppercase font-bold text-gray-400 mb-1">Terms & Conditions</p>
            <ul className="text-[10px] text-gray-400 list-disc pl-4 leading-tight">
              {seller.terms.map((term, i) => <li key={i}>{term}</li>)}
            </ul>
          </div>
          <div className="text-right flex flex-col justify-end">
            <p className="text-xs text-gray-400 italic mb-8">Authorized Signatory</p>
            <div className="h-px w-32 ml-auto bg-gray-300"></div>
          </div>
        </div>
        {/* <p className="text-center text-[10px] text-gray-300 mt-10">
          View our <a href={seller.privacyPolicyUrl} className="underline">Privacy Policy</a>. Generated electronically.
        </p> */}
      </div>
    </div>
  );
};

export default MinimalInvoice;